import type {CompanyRegistrationFormData} from '@openapi/company-registration-form';
import {companyRegistrationApi} from '../client';

export const postRegister = async (
  companyRegistrationFormData: CompanyRegistrationFormData,
) => companyRegistrationApi.register({companyRegistrationFormData});
